import { breakpointUp } from './breakpoints'
import { updateLocoScroll, startLocoScroll} from '../locomotive-scroll'
import { openPopup } from './popups'

let globalHash = window.location.hash
export function setUpNavigation(locoScroll) {
  let toHash = $('.js-go-to')

  if (globalHash) {
    goToHash(globalHash)
  }


  // go to hash
  toHash.click(function (e) {
    e.preventDefault()
    let goTo = '#' + $(this).data('go-to')
    goToHash(goTo)
  })


  //-- Set active menu el
  let navigationBlocks = $('.js-nav-block')
  if (breakpointUp('lg')) {

    locoScroll.on('scroll', (data) => {
      let currentEl = ''
      navigationBlocks.each(function (index) {
        if ($(this).attr('id').length) {
          let elemTop = $(this).offset().top - 100
          if (elemTop < 0) currentEl = $(this)
        }
      })
      setActiveElement(currentEl)
    })

  } else {

    $(window).bind('scroll', function () {
      let currentTop = $(window).scrollTop()
      let currentEl = ''
      navigationBlocks.each(function (index) {
        if ($(this).attr('id').length) {
          let elemTop = $(this).offset().top - 100
          if (currentTop >= elemTop) currentEl = $(this)
        }
      })
      setActiveElement(currentEl)

    })

  } // end set active menu el


  let lastActive = ''
  function setActiveElement(el){
    let id = $(el).attr('id')
    if (lastActive !== id) {
      lastActive = id
      let navElem = $('[data-go-to="' + id + '"]')

      if (!el) id = ''
      toHash.removeClass('js-active')
      navElem.addClass('js-active')
      setUrlHash(id)
    }
  }

  function goToHash (hash) {
    if (hash) {
      hash = hash.replace('#', '')
      hash = hash.replace('/', '')
      let hashEl = ''
      let isPopup = 0

      if (hash.search('popup-') !== -1){
        if (hash !== 'popup-video-popup') {
          hashEl = hash.replace('popup-', '')
          isPopup = 1
        }
      } else {
        hashEl = $('#' + hash)
      }

      if (hashEl.length) {
        if (isPopup){
          openPopup(hashEl, locoScroll)
        } else {
          if (breakpointUp('lg')) {
            startLocoScroll()
            locoScroll.scrollTo(hashEl[0], { duration: 600, callback: updateLocoScroll })
          } else {
            $('html, body').animate({ scrollTop: hashEl.offset().top })
          }
        }
      }
      //setUrlHash(hash)
    }
  }


  $('.js-go-up').click(function (){
    if (breakpointUp('lg')) {
      startLocoScroll()
      locoScroll.scrollTo(0, { duration: 600, callback: updateLocoScroll })
    } else {
      $('html, body').animate({ scrollTop: 0 })
    }
  })

}


let lastHistory = '';
let hashTimeout = 0;
export function setUrlHash (hash) {
  if (lastHistory !== hash && !hashTimeout) {
    lastHistory = hash
    if (window.history && window.history.pushState) {
      let curUrl = window.location.href.split(/[?#]/)[0]
      if (hash) hash = '#' + hash
      history.pushState({}, null, curUrl + hash)
      hashTimeout = 1
      setTimeout(function(){hashTimeout = 0}, 300)
    }
  }
}
